"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Vip = function Vip(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.25 6.75L17.25 0.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.25 6.75L20.25 0.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.25.75H21a2.25,2.25,0,0,1,0,4.5h-.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.25.75V1.8a8.932,8.932,0,0,0,1.5,4.954A8.932,8.932,0,0,0,14.25,1.8V.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.375 4.874 A2.625 2.625 0 1 0 8.625 4.874 A2.625 2.625 0 1 0 3.375 4.874 Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.667,23.241a1.5,1.5,0,0,1-1.659-1.325l-.379-3.4a1.491,1.491,0,0,0-1.481-1.271H8.02a2.992,2.992,0,0,1-2.959-2.5L4.52,11.5A1.5,1.5,0,1,1,7.479,11l.541,3.246h2.128a4.478,4.478,0,0,1,4.446,3.808c.006.042.4,3.526.4,3.526A1.5,1.5,0,0,1,13.667,23.241Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.75,23.25H8.132a.9.9,0,0,0,.895-1L8.892,21.03a.879.879,0,0,0-.872-.781A5.983,5.983,0,0,1,2.1,15.241l-.331-1.988A1.5,1.5,0,0,0,.73,12.065",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  })));
};
Vip.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Vip.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Vip;